import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Loader2 } from "lucide-react";
import { AiAssetBadge } from "./AiAssetBadge";
import { AssetPricingBadge } from "./AssetPricingBadge";

/**
 * Phase 25b · Horizontal carousel of 8 newest assets (created_at desc).
 */
export function MarketplaceNewCarousel({ items = [], loading, onOpen }) {
  return (
    <section data-testid="mp-new-carousel" className="space-y-3">
      <header>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-text-secondary mb-1">
          <Sparkles className="h-3 w-3 text-[var(--color-secondary)]" /> New arrivals
        </div>
        <h2 className="text-lg font-semibold tracking-tight text-[var(--color-text-main)]">
          Fresh drops
        </h2>
      </header>
      {loading ? (
        <div className="flex items-center gap-2 text-xs text-text-secondary py-6">
          <Loader2 className="h-3 w-3 animate-spin" /> Loading…
        </div>
      ) : items.length === 0 ? (
        <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-8 text-center text-xs text-text-secondary">
          Nessun nuovo asset disponibile.
        </div>
      ) : (
        <div className="grid grid-flow-col auto-cols-[minmax(230px,1fr)] gap-3 overflow-x-auto pb-3 snap-x snap-mandatory">
          {items.slice(0, 8).map((it) => (
            <Link
              key={it.asset_id}
              to={`/marketplace/asset/${it.asset_id}`}
              onClick={() => onOpen && onOpen(it)}
              data-testid={`mp-new-card-${it.asset_id}`}
              className="group snap-start rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-4 hover:border-[var(--color-secondary)]/60 transition-colors block"
            >
              <div className="flex items-center justify-between mb-2">
                <AssetPricingBadge is_paid={it.is_paid} price_eur_cents={it.price_eur_cents} size="sm" />
                {(it.creator_type === "virtual" || it.ai_generated) && (
                  <AiAssetBadge assetAiType={it.asset_ai_type} />
                )}
              </div>
              <h3 className="text-sm font-semibold text-[var(--color-text-main)] line-clamp-2 group-hover:text-[var(--color-secondary)] transition-colors">
                {it.title}
              </h3>
              <p className="text-[11px] text-text-secondary mt-2 line-clamp-2 leading-snug">
                {it.description || ""}
              </p>
              <div className="mt-3 text-[10px] uppercase tracking-widest text-text-secondary">
                {it.category || "general"}
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}

export default MarketplaceNewCarousel;
